import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "CreateEditProjectModal",
  props: {
    dataRecord: {
      type: Object,
      default: function () {
        return {};
      },
    },
    visibleModal: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    handleCancel: Function,
  },
  data() {
    return {
      formRQ: this.$form.createForm(this, {
        name: "formRQ",
      }),
      formData: {},
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16, offset: 1 },
      },
      isLoading: false,
      timeoutAllStaff: null,
      listDepartment: []
    };
  },
  watch: {
    departmentList (newValue) {
      this.listDepartment = newValue
    }

  },
  computed: {
    ...mapState({
      employeeList: (state) => state.application.employeeList,
      departmentList: (state) => state.application.departmentList,
    }),
  },
  created() {
    this.onHandleGetListDepartment()
    if (this.isEdit) {
      const { department, start_date, end_date, pms, project_name, project_code, project_id } = this.dataRecord
      this.formData = {
        projectId: project_id,
        projectName: project_name,
        projectCode: project_code,
        department: department,
        pms: pms.map((item) => item.pm_user_name),
        choose_date: [moment(start_date, "DD/MM/YYYY HH:mm:ss"), moment(end_date, "DD/MM/YYYY HH:mm:ss")]
      }
    }
  },
  methods: {
    moment,
    onOK() {
      this.formRQ.validateFields((err, values) => {
        if (err) return;
        if (this.isEdit) {
          let payload = {
            projectId: values.projectId,
            projectName: values.projectName,
            projectCode: values.projectCode,
            department: values.department,
            pms: values.pms ? values.pms.map(item => {
              return ({ userName: item })
            }) : [],
            startDate: moment(values.choose_date[0]).format("YYYY-MM-DD"),
            endDate: moment(values.choose_date[1]).format("YYYY-MM-DD"),
            id: this.dataRecord.id
          }
          this.$emit("onOKEditProject", payload);
        } else {
          let payload = {
            projectId: values.projectId,
            projectName: values.projectName,
            projectCode: values.projectCode,
            department: values.department,
            pms: values.pms ? values.pms.map(item => {
              return ({ userName: item })
            }) : [],
            startDate: moment(values.choose_date[0]).format("YYYY-MM-DD"),
            endDate: moment(values.choose_date[1]).format("YYYY-MM-DD"),
          }
          this.$emit("onOKAddProject", payload);
        }
      });
    },

    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      this.isLoading = true;
      clearTimeout(this.timeoutAllStaff);
      this.timeoutAllStaff = setTimeout(() => {
        this.$store
          .dispatch("application/getEmployeeList", cloneVal)
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }, timeout);
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    onSearchDepartment (value) {
      this.listDepartment = this.departmentList.filter(item => {
        return item.name.toLowerCase().indexOf(value.toLowerCase()) >= 0 || ( item.department_code.toLowerCase().indexOf(value.toLowerCase()) >= 0)
      })
    },

    onHandleGetListDepartment() {
      this.$store
        .dispatch("application/getDepartmentList")
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    onCancel() {
      this.handleCancel();
      this.formRQ.resetFields();
    },
  },
};
